module.exports = __webpack_public_path__ + "static/Sam-adams-issue1-37cde8fd18f700803b3f2a06dee405eb.png";